/**
 * Task list advanced filter field definitions (no Status — use Open/Closed control in filter panel).
 * @param {object[]} projects
 */
export function getTaskAdvancedFilterFieldDefs(projects = []) {
  const list = Array.isArray(projects) ? projects : [];
  const projectOptions = [...list]
    .filter((p) => p && p._id)
    .map((p) => ({
      value: String(p._id),
      label: String(p.name || "").trim() || String(p._id),
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  return [
    {
      id: "nameNotes",
      label: "Name / Notes",
      type: "text",
      placeholder: "Type keywords…",
    },
    {
      id: "project_id",
      label: "Project",
      type: "select",
      allLabel: "All Projects",
      options: projectOptions,
    },
    {
      id: "priority",
      label: "Priority",
      type: "select",
      allLabel: "All Priorities",
      options: [
        { value: "Low", label: "Low" },
        { value: "Medium", label: "Medium" },
        { value: "High", label: "High" },
        { value: "__not_set__", label: "Not set" },
      ],
    },
  ];
}
